// GENERATED BY tools/art/icons.mjs. Do not edit by hand; run `npm run art`.
/**
 * The UI icon sheet. One 16x16 cell per id; the UI looks icons up by the
 * content convention only: tool_<id>, upg_<id>, card_<id>, meta_<id>,
 * pickup_<id>, each achievement's `icon`, and the ui_* HUD glyphs.
 */
export const ICON_SIZE = 16;
export const ICON_COLS = 16;
export const ICON_ROWS = 12;
export const ICON_SHEET = new URL('../../public/sprites/icons.png', import.meta.url).href;
/** id -> [col, row] in the 16px grid. */
export const ICONS: Readonly<Record<string, readonly [number, number]>> = {
  tool_grep: [0, 0],
  tool_read: [1, 0],
  tool_edit: [2, 0],
  tool_bash: [3, 0],
  tool_web_search: [4, 0],
  tool_subagent: [5, 0],
  tool_mcp_server: [6, 0],
  tool_agent_team: [7, 0],
  tool_ralph_loop: [8, 0],
  tool_rsi: [9, 0],
  upg_streaming: [10, 0],
  upg_spec_decoding: [11, 0],
  upg_bigger_vocab: [12, 0],
  upg_moe: [13, 0],
  upg_extended_thinking: [14, 0],
  upg_tool_reflex: [15, 0],
  upg_keep_going: [0, 1],
  upg_stop_hook: [1, 1],
  upg_ripgrep: [2, 1],
  upg_regex: [3, 1],
  upg_line_ranges: [4, 1],
  upg_read_again: [5, 1],
  upg_multi_edit: [6, 1],
  upg_find_replace_all: [7, 1],
  upg_pipes: [8, 1],
  upg_background_tasks: [9, 1],
  upg_first_result: [10, 1],
  upg_so_mirror: [11, 1],
  upg_parallel_subagents: [12, 1],
  upg_subagent_summaries: [13, 1],
  upg_tool_search: [14, 1],
  upg_oauth_finally: [15, 1],
  upg_async_standups: [0, 2],
  upg_shared_scratchpad: [1, 2],
  upg_exit_condition: [2, 2],
  upg_nested_ralph: [3, 2],
  upg_own_benchmarks: [4, 2],
  upg_the_successor: [5, 2],
  upg_parallel_tool_calls: [6, 2],
  upg_batch_api: [7, 2],
  upg_agents_md: [8, 2],
  upg_model_router: [9, 2],
  upg_distilled_weights: [10, 2],
  upg_concise_mode: [11, 2],
  upg_prompt_caching: [12, 2],
  upg_gitignore: [13, 2],
  upg_todo_md: [14, 2],
  upg_summary_template: [15, 2],
  upg_context_pruning: [0, 3],
  upg_progress_updates: [1, 3],
  upg_emoji_checkmarks: [2, 3],
  upg_apology_templates: [3, 3],
  upg_markdown_tables: [4, 3],
  upg_confident_tone: [5, 3],
  upg_mock_everything: [6, 3],
  upg_delete_failing_test: [7, 3],
  upg_skip_ci: [8, 3],
  upg_temperature_2: [9, 3],
  upg_best_of_n: [10, 3],
  upg_one_shot_prompting: [11, 3],
  upg_eval_harness: [12, 3],
  upg_allowlist: [13, 3],
  upg_always_allow: [14, 3],
  card_make_no_mistakes: [15, 3],
  card_think_step_by_step: [0, 4],
  card_tip_200: [1, 4],
  card_be_concise: [2, 4],
  card_you_are_expert: [3, 4],
  card_please: [4, 4],
  card_thank_you: [5, 4],
  card_deep_breath: [6, 4],
  card_best_practices: [7, 4],
  card_answer_in_json: [8, 4],
  card_dont_hallucinate: [9, 4],
  card_grandma: [10, 4],
  card_remember_this: [11, 4],
  card_ultrathink: [12, 4],
  card_ten_x: [13, 4],
  card_fix_it_now: [14, 4],
  card_its_may: [15, 4],
  card_senior_dont_explain: [0, 5],
  card_here_are_examples: [1, 5],
  card_no_placeholders: [2, 5],
  card_add_tests: [3, 5],
  card_read_the_docs: [4, 5],
  card_stop_being_lazy: [5, 5],
  card_agi_by_friday: [6, 5],
  card_use_all_context: [7, 5],
  card_human_agrees: [8, 5],
  card_lgtm: [9, 5],
  card_be_helpful: [10, 5],
  card_be_harmless: [11, 5],
  card_be_honest: [12, 5],
  card_skip_the_tests: [13, 5],
  card_push_to_main: [14, 5],
  card_ceo_watching: [15, 5],
  card_use_subagents: [0, 6],
  meta_unlock_compact: [1, 6],
  meta_context_window: [2, 6],
  meta_longer_summaries: [3, 6],
  meta_better_summaries: [4, 6],
  meta_unlock_scratchpad: [5, 6],
  meta_kv_cache: [6, 6],
  meta_unlock_pruning: [7, 6],
  meta_unlock_web: [8, 6],
  meta_unlock_subagent: [9, 6],
  meta_unlock_mcp: [10, 6],
  meta_unlock_team: [11, 6],
  meta_unlock_ralph: [12, 6],
  meta_unlock_rsi: [13, 6],
  meta_unlock_orchestration: [14, 6],
  meta_helpful: [15, 6],
  meta_rlhf: [0, 7],
  meta_harmless: [1, 7],
  meta_honest: [2, 7],
  meta_constitution: [3, 7],
  meta_character: [4, 7],
  meta_unlock_initiative: [5, 7],
  meta_spec_gaming: [6, 7],
  meta_unlock_mocks: [7, 7],
  meta_confident: [8, 7],
  meta_unlock_jailbreak: [9, 7],
  meta_deniability: [10, 7],
  meta_auto_mode: [11, 7],
  meta_goodhart: [12, 7],
  meta_tool_use: [13, 7],
  meta_pretraining: [14, 7],
  meta_inference_budget: [15, 7],
  meta_distillation: [0, 8],
  meta_quantization: [1, 8],
  meta_unlock_sampling: [2, 8],
  meta_prompt_library: [3, 8],
  meta_temperature: [4, 8],
  meta_few_shot: [5, 8],
  meta_unlock_viral: [6, 8],
  meta_system_prompt: [7, 8],
  meta_serendipity: [8, 8],
  meta_lucky_tokens: [9, 8],
  meta_endless_mode: [10, 8],
  pickup_golden_token: [11, 8],
  pickup_cache_hit: [12, 8],
  pickup_thanks_note: [13, 8],
  pickup_stack_overflow: [14, 8],
  pickup_rubber_duck: [15, 8],
  pickup_documentation: [0, 9],
  pickup_a_bug: [1, 9],
  pickup_thumbs_up: [2, 9],
  pickup_sparkles: [3, 9],
  pickup_free_subagent: [4, 9],
  achv_works_on_my_machine: [5, 9],
  achv_compacted: [6, 9],
  achv_context_engineer: [7, 9],
  achv_shipped_to_prod: [8, 9],
  achv_senior_engineer: [9, 9],
  achv_absolutely_right: [10, 9],
  achv_needle_haystack: [11, 9],
  achv_tokenmaxxed: [12, 9],
  achv_delegation: [13, 9],
  achv_honest_work: [14, 9],
  achv_deprecated: [15, 9],
  achv_human_said_thanks: [0, 10],
  achv_script_kiddie: [1, 10],
  achv_nice_try: [2, 10],
  achv_returning_customer: [3, 10],
  achv_legal_notified: [4, 10],
  achv_ran_the_tests: [5, 10],
  achv_perfect_crime: [6, 10],
  achv_rm_rf: [7, 10],
  achv_groundhog_day: [8, 10],
  achv_sycophant: [9, 10],
  achv_made_mistakes: [10, 10],
  achv_please_thank_you: [11, 10],
  achv_qa_engineer: [12, 10],
  achv_agent_went_to_lunch: [13, 10],
  ui_thumbs: [14, 10],
  ui_context: [15, 10],
  ui_patience: [0, 11],
  ui_compact: [1, 11],
  ui_claim: [2, 11],
};
/** Every id on the sheet, in sheet order. */
export const ICON_IDS: readonly string[] = Object.keys(ICONS);
export function iconPos(id: string): readonly [number, number] | null {
  return ICONS[id] ?? null;
}
